export default function getEnvVar(key, defaultValue = null) {
    try {
        return process.env?.[key] ?? defaultValue;
    } catch (_) {
        return defaultValue;
    }
}
